import { render, staticRenderFns } from "./AddLogoForm.vue?vue&type=template&id=bc7fc07e&"
import script from "./AddLogoForm.vue?vue&type=script&lang=js&"
export * from "./AddLogoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports